export default __webpack_public_path__ + "static/media/city-map.a6b4fce1.svg";